import React, { PureComponent } from "react";
import { Link, GridContainer, Row, Column, Typography } from "@vp/swan";
import l10n from "../../localization/localization";
import PreferenceCategory from "./preference-category";
import getUrl from "../get-url";
import { Mode } from "../../constants";

export default class PreferenceCa extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { advertising, functional, sessionReplay, mode } = this.props;

    const position = this.getPosition(mode);

    const categories = [
      {
        name: "necessary",
        enabled: true,
        readonly: true,
      },
      {
        name: "functional",
        enabled: functional,
        readonly: false,
      },
      {
        name: "sessionReplay",
        enabled: sessionReplay,
        readonly: false,
      },
      {
        name: "advertising",
        enabled: advertising,
        readonly: false,
      },
    ];

    return (
      <GridContainer marginBottom="7">
        <Row marginBottom={"6"}>
          <Column
            {...position}
            align="left"
            id="consent-dialog-description"
            aria-label={l10n.t("preferenceDialogV5.content")}
          >
            {this.getPolicyTextComponent()}
          </Column>
        </Row>
        {categories.map((category) => (
          <PreferenceCategory
            key={category.name}
            category={category}
            handleChange={this.handleChange}
            mode={mode}
          />
        ))}
      </GridContainer>
    );
  }

  getPosition(mode) {
    if (mode === Mode.Embedded) {
      return {
        span: 12,
      };
    }

    return {
      offsetLg: 3,
      spanLg: 6,
      offset: 1,
      span: 10,
      spanXs: 12,
    };
  }

  getPolicyLink = () => {
    return getUrl(l10n.tUrl("privacyAndCookiePolicy"));
  };

  getPolicyTextComponent() {
    const content = l10n.t("preferenceDialogV5.content");
    const parts = content.split("#policy-link#");
    const linkText = l10n.t("preferenceDialogV5.policyLinkText");
    const linkHref = this.getPolicyLink();

    const renderWithBreaks = (text, keyPrefix) => {
      return text.split("#break#").map((part, idx, arr) => [
        <React.Fragment key={`${keyPrefix}-part-${idx}`}>
          {part}
        </React.Fragment>,
        idx < arr.length - 1 ? (
          <React.Fragment key={`${keyPrefix}-brs-${idx}`}>
            <br />
            <br />
          </React.Fragment>
        ) : null,
      ]);
    };

    return (
      <>
        {renderWithBreaks(parts[0], "before-link")}
        <Link href={linkHref}>{linkText}</Link>
        {parts[1] && renderWithBreaks(parts[1], "after-link")}
      </>
    );
  }

  handleChange = (name, activated) => {
    const { onChange } = this.props;

    onChange(name, activated);
  };
}
